import React from 'react'
import { Check } from '../../../assets/icons'
import {
  CheckListContainer,
  CheckListItem,
  CheckListItemContent,
  HiddenCheckbox,
  StyledCheckbox,
  EmptyState
} from './styled'

const CheckList = ({
  options = [],
  selectedValues = [],
  onToggle,
  maxHeight = 'none',
  searchedText = '',
  maxSelected = 3
}) => {
  if (!options.length) {
    return (
      <EmptyState>
        {searchedText
          ? `No tenemos resultados para "${searchedText}"`
          : 'No hay opciones para mostrar'}
      </EmptyState>
    )
  }

  return (
    <CheckListContainer $maxHeight={maxHeight}>
      {options.map(option => {
        const isSelected = selectedValues.includes(option.value)
        const isDisabled = !isSelected && selectedValues.length >= maxSelected

        return (
          <CheckListItem
            key={option.value}
            $disabled={isDisabled}
            onClick={() => !isDisabled && onToggle && onToggle(option)}
            style={isDisabled ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
          >
            <CheckListItemContent>
              <HiddenCheckbox
                checked={isSelected}
                onChange={() => {}}
                onClick={event => event.stopPropagation()}
              />
              <StyledCheckbox $checked={isSelected} $disabled={isDisabled}>
                {isSelected && <Check />}
              </StyledCheckbox>
              <span style={{ fontSize: '14px', fontWeight: 600 }}>{option.label}</span>
            </CheckListItemContent>
          </CheckListItem>
        )
      })}
    </CheckListContainer>
  )
}

export default CheckList
